import { render } from "./inputDate.vue?vue&type=template&id=2afe6baa&scoped=true"
import script from "./inputDate.vue?vue&type=script&lang=js"
export * from "./inputDate.vue?vue&type=script&lang=js"

import "./inputDate.vue?vue&type=style&index=0&id=2afe6baa&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afe6baa"]])

export default __exports__